(function () {
  if (customElements.get('ss-cart-suggestions')) return;
  var cache = {};

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  class SsCartSuggestions extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.hidden = true;
      var title = this.dataset.title || 'You may also like';
      this.innerHTML = '<h3 class="ss-sugg__h"></h3><div data-slot></div>';
      this.querySelector('.ss-sugg__h').textContent = title;
      this.addEventListener('click', this.onClick.bind(this));
      this.load();
    }

    show(html) {
      this.querySelector('[data-slot]').innerHTML = '<ul class="ss-sugg__list">' + html + '</ul>';
      this.hidden = false;
    }

    async load() {
      var seed = this.dataset.seed;
      var key = this.dataset.key || seed || 'none';
      if (cache[key]) return this.show(cache[key]);
      var urls = [];
      if (seed) {
        urls.push(root() + 'recommendations/products?section_id=ss-cart-suggestions-items&product_id=' + encodeURIComponent(seed) + '&limit=10&intent=related');
      }
      urls.push(root() + '?section_id=ss-cart-suggestions-items');
      for (var i = 0; i < urls.length; i++) {
        try {
          var r = await fetch(urls[i], { headers: { Accept: 'text/html' } });
          if (!r.ok) continue;
          var doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          var list = doc.querySelector('[data-ss-items]');
          if (list && list.children.length) {
            cache[key] = list.innerHTML;
            return this.show(cache[key]);
          }
        } catch (e) {}
      }
      this.hidden = true;
    }

    onClick(e) {
      var b = e.target.closest('.ss-sugg__add');
      if (!b || b.disabled) return;
      e.preventDefault();
      var id = b.dataset.variantId;
      if (!id) return;
      var label = b.textContent;
      var onPage = this.dataset.context === 'page';
      b.disabled = true;
      b.textContent = 'Adding...';
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(id),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
          var drawer = document.querySelector('cart-drawer');
          if (onPage || !drawer || typeof drawer.renderContents !== 'function' || !res.j.sections) {
            window.location.reload();
            return;
          }
          drawer.renderContents(res.j);
        })
        .catch(function () {
          b.textContent = 'Try again';
          b.disabled = false;
          setTimeout(function () { if (b.textContent === 'Try again') b.textContent = label; }, 2500);
        });
    }
  }

  customElements.define('ss-cart-suggestions', SsCartSuggestions);
})();
